import styled from 'styled-components'

export default styled.div`
  position: relative;
  height: 100%;

  .marker {
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 18px;
    letter-spacing: 0;
    line-height: 20px;
    color: ${ ({ theme }) => theme.colors.greyDark };
    padding: 0 12px 0 8px;
    user-select: none;
  }

  .gm-style .gm-style-iw-c {
    border-radius: 22px;
    cursor: pointer;

    > button {
      top: 8px !important;
    }
  }

  &.markers-options {
    visibility: hidden;
    height: 0;
  }

  /* The pin's tip marks the centre, so the whole image sits above it. */
  .center-pin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
    pointer-events: none;
    z-index: 4;

    /* Each variant has its own height (the flying one is taller), so only the
       shared width is fixed — forcing both axes stretches the pin. */
    img {
      display: block;
      width: 35px;
      height: auto;
    }
  }

  /* Right-hand column of controls, bottom up: Google's fullscreen, suggest a stop, recenter. */
  .suggestion-container {
    position: absolute;
    bottom: 110px;
    right: 5px;
    z-index: 5;
  }

  .recenter-container {
    position: absolute;
    bottom: 75px;
    right: 5px;
    padding: 5px;
    border-radius: 50%;
    cursor: pointer;
    background-color: ${ ({ theme }) => theme.colors.white };
    
    img {
      width: 16px;
      height: 16px;
    }
  }

  .marker-infowindow {
    min-width: 150px;
    max-width: 280px;
    padding: 4px;
    display: flex;
    flex-direction: column;
    gap: 6px;

    .stop-row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      cursor: pointer;
    }

    span {
      font-weight: bold;
    }

    .departures {
      display: flex;
      flex-direction: column;
      gap: 4px;
      border-top: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      padding-top: 6px;

      .departure {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        border-left: 3px solid transparent;
        padding-left: 6px;

        img {
          width: 14px;
          height: 14px;
        }

        .departure-time {
          font-weight: 600;
        }

        .departure-destination {
          color: ${ ({ theme }) => theme.colors.greyDark };
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .schedules-button {
      align-self: flex-start;
      background: none;
      border: none;
      padding: 2px 0;
      cursor: pointer;
      font-family: inherit;
      font-size: 13px;
      font-weight: 600;
      text-decoration: underline;
      color: ${ ({ theme }) => theme.colors.primary };
    }
    .marker-dot {
      width: 16px;
      height: 16px;
      border-radius: 10px;
      position: relative;
    }

    .marker-white {
      position: absolute;
      top: 4px;
      left: 4px;
      width: 8px;
      height: 8px;
      border-radius: 5px;
      background-color: ${ ({ theme }) => theme.colors.white }
    }
  }
`
